/**
 * Réduction d'un texte markdown à un résumé en clair.
 *
 * Module pur (sans dépendance React ni Supabase) → testé en unitaire
 * (`md-excerpt.test.ts`). Utilisé pour afficher la mise en situation d'un
 * exercice dans les cartes de la page thème.
 */

/**
 * Retire la syntaxe markdown et les formules d'un texte, puis le tronque sans
 * couper un mot. Renvoie une chaîne en clair d'au plus `maxLength` caractères.
 */
export function mdExcerpt(md: string, maxLength = 200): string {
  const text = md
    .replace(/\$\$[\s\S]*?\$\$/g, ' ') // math display
    .replace(/\$[^\n$]*\$/g, ' ') // math inline
    .replace(/```[\s\S]*?```/g, ' ') // blocs de code
    .replace(/`([^`]*)`/g, '$1') // code inline
    .replace(/!\[[^\]]*\]\([^)]*\)/g, ' ') // images
    .replace(/\[([^\]]*)\]\([^)]*\)/g, '$1') // liens → libellé
    .replace(/^[ \t]*#{1,6}[ \t]+/gm, '') // titres
    .replace(/^[ \t]*>[ \t]?/gm, '') // citations
    .replace(/^[ \t]*[-*+][ \t]+/gm, '') // puces
    .replace(/^[ \t]*\d+\.[ \t]+/gm, '') // listes numérotées
    .replace(/\*\*([^*]+)\*\*/g, '$1') // gras
    .replace(/\*([^*]+)\*/g, '$1') // italique
    .replace(/__([^_]+)__/g, '$1') // gras alt
    .replace(/\s+/g, ' ')
    .trim();

  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength).replace(/\s+\S*$/, '') + '…';
}
